import $ from 'jquery';

export default class ExtLinks {
  constructor(element) {
    this.$element = $(element);
    this.ready();
  }

  ready() {
    this.$element.attr('rel', 'noreferrer');
  }
}
